import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer, createTransform } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import themeReducer from './slices/theme/themeSlice';
import authReducer from './slices/auth/authSlice';
import deviceReducer from './slices/device/deviceSlice';
import appReducer from './slices/appSlice';
import { TypedUseSelectorHook, useSelector } from 'react-redux';

// 创建自定义转换器，避免使用eval()
const SafeTransform = createTransform(
  // 序列化: 将状态转换为存储格式
  (inboundState) => {
    return JSON.stringify(inboundState);
  },
  // 反序列化: 将存储数据转换回状态
  (outboundState) => {
    return typeof outboundState === 'string' 
      ? JSON.parse(outboundState) 
      : outboundState;
  }
);

const rootPersistConfig = {
  key: 'root',
  storage,
  whitelist: ['theme', 'auth', 'device'],
  transforms: [SafeTransform],
};

const rootReducer = combineReducers({
  theme: themeReducer,
  auth: authReducer,
  device: deviceReducer,
  app: appReducer,
});

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;